import { Select, message } from "antd"
import React, { useEffect, useState } from "react"
import DropdownService from "src/services/DropdownService"

const SelectLotNumber = ({
  value,
  onChange,
  disabled,
  style = { height: "36px" },
  isView,
}) => {
  const [lots, setLots] = useState([])

  useEffect(() => {
    fetchLotNumbers()
  }, [])


const fetchLotNumbers = async () => {
  try {
    const response = await DropdownService.getWarehouseApproval()
    console.log("response:", response)
    const data = response?.success
    setLots(Object.values(response?.success || {}))
  } catch (error) {
    console.error("Lỗi khi lấy danh sách số lô", error)
    message.error("Không thể lấy danh sách số lô")
  }
}

  return (
    <Select
      placeholder="Chọn số lô"
      title="Chọn số lô"
      allowClear
      showSearch
      value={value}
      onChange={onChange}
      style={style}
      disabled={disabled}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option.label?.toLowerCase().includes(input.toLowerCase())
      }
      options={lots.map(item => ({
        label: item.batch_number,
        value: item.ID,
      }))}
    />
  )
}

export default SelectLotNumber
